import { render, staticRenderFns } from "./CopyUrlModal.vue?vue&type=template&id=5727b66c&"
import script from "./CopyUrlModal.vue?vue&type=script&lang=js&"
export * from "./CopyUrlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports